import {setCookiePopup} from './newsletter'

export default () => {

    const popup = document.querySelector('.js-newsletter-popup');

    if(!popup) {
        return;
    }

    function getCookie(cookieName) {
		var name = cookieName + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var cookieArray = decodedCookie.split(';');
		
		for (var i = 0; i < cookieArray.length; i++) {
		  var cookie = cookieArray[i].trim();
		  if (cookie.indexOf(name) === 0) {
			return cookie.substring(name.length, cookie.length);
		  }
		}
		
		return null;
	}

    const isPopupOpened = getCookie('issubscribed');

    if(!isPopupOpened) {
        popup.classList.add('newsletter-popup--visible');
        popup.style.display = "block";
    }

    const closeBtn = popup.querySelector('.js-newsletter-popup-close');

    closeBtn.addEventListener('click', () => {
        popup.classList.remove('newsletter-popup--visible'); 
        setTimeout(() => {
          popup.style.display = "none";
        }, 600)
       
        setCookiePopup('close');
    })

}